/* Grafilabel: productkaarten per rij gelijk trekken (16 okt 2026).
   Op smalle schermen loopt een kenmerk ("Voor Hallo 1YS en Open PH6") soms over twee regels,
   waardoor prijs, vanaf-regel en knop per kaart op een andere hoogte komen. Dit script geeft
   het kenmerkenblok van alle kaarten die naast elkaar staan de hoogte van het hoogste blok in
   die rij. De volledige tekst blijft staan. Werkt opnieuw bij draaien, filteren en meer laden.
   Geladen door snippets/gl-card-vanaf.liquid (per kaart, maar draait maar één keer). */
(function () {
  if (window.glCardRows) return;
  window.glCardRows = true;

  var SPECS = '.card__specs';

  function run() {
    var lists = document.querySelectorAll('ul');
    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i];
      var items = [];
      for (var c = 0; c < ul.children.length; c++) {
        var li = ul.children[c];
        var specs = li.querySelector('.card--gl ' + SPECS);
        if (specs) items.push({ li: li, specs: specs });
      }
      if (items.length < 2) continue;

      items.forEach(function (it) { it.specs.style.minHeight = ''; });

      var rows = {};
      items.forEach(function (it) {
        var top = Math.round(it.li.offsetTop);
        (rows[top] = rows[top] || []).push(it);
      });

      Object.keys(rows).forEach(function (key) {
        var row = rows[key];
        if (row.length < 2) return;
        var max = 0;
        row.forEach(function (it) { max = Math.max(max, it.specs.offsetHeight); });
        row.forEach(function (it) { it.specs.style.minHeight = max + 'px'; });
      });
    }
  }

  // setTimeout in plaats van requestAnimationFrame: rAF staat stil in een tabblad op de achtergrond.
  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 60);
  }

  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      if (mutations[m].addedNodes.length) { schedule(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
